<template>
  <v-content style="position: relative;" class="tablet">
    <v-flex style="position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
      <v-flex xs12 v-show="frontPage && hasContractorRole">
        <v-btn @click="gotoProduction" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start production
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasLoaderRole || hasCarrierRole || hasSupplierRole)">
        <v-btn @click="gotoLoading" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start loading
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasLoaderRole || hasCarrierRole)">
        <v-btn @click="gotoUnloading" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start unloading
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasRepackagingRole">
        <v-btn @click="gotoRepackaging" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start repackaging
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasLabellerRole">
        <v-btn @click="gotoLabelling" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start labelling
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasTimeRegistrationRole">
        <v-btn @click="gotoTimeRegistration" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Time registration
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasSupplierRole)">
        <v-btn @click="gotoProductionReport" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Production report
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasSupplierRole">
        <v-btn @click="gotoSupplierStatus" :style="'height: ' + Math.min(65 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (45 - (4 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Supplier status
        </v-btn>
      </v-flex>
    </v-flex>

    <TodoProduction v-if="productionVisible"/>
    <TodoLoading v-if="loadingVisible"/>
    <TodoUnloading v-if="unloadingVisible"/>
    <TodoRepackaging v-if="repackagingVisible"/>
    <TodoLabelling v-if="labellingVisible"/>
    <TodoTimeRegistration v-if="timeRegistrationVisible"/>
    <ProductionReport v-if="productionReportVisible"/>
    <SupplierStatus v-if="supplierStatusVisible"/>
  </v-content>
</template>

<script>
import Panel from '../components/Panel'
import TodoProduction from './TodoProduction'
import TodoLabelling from './TodoLabelling'
import TodoLoading from './TodoLoading'
import TodoUnloading from './TodoUnloading'
import TodoRepackaging from './TodoRepackaging'
import TodoTimeRegistration from './TodoTimeRegistration'
import ProductionReport from './ProductionReport'
import SupplierStatus from './SupplierStatus'

export default {
  name: 'Content',
  components: { Panel, TodoProduction, TodoLabelling, TodoLoading, TodoUnloading, TodoRepackaging, ProductionReport, SupplierStatus, TodoTimeRegistration },
  data () {
    return {
      frontPage: true,
      productionVisible: false,
      loadingVisible: false,
      unloadingVisible: false,
      repackagingVisible: false,
      labellingVisible: false,
      timeRegistrationVisible: false,
      productionReportVisible: false,
      supplierStatusVisible: false
    }
  },
  created: function () {
  },
  computed: {
    fullName: function () {
      return this.$store.state.session.fullName
    },
    roles: function () {
      return this.$store.state.session.roles
    },
    hasContractorRole: function () {
      return this.$store.getters['session/hasRole']('CONTRACTOR') && !this.hasTimeRegistrationRole
    },
    hasCustomerRole: function () {
      return this.$store.getters['session/hasRole']('CUSTOMER') && !this.hasTimeRegistrationRole
    },
    hasLoaderRole: function () {
      return this.$store.getters['session/hasRole']('LOADER') && !this.hasTimeRegistrationRole
    },
    hasSupplierRole: function () {
      return this.$store.getters['session/hasRole']('SUPPLIER') && !this.hasTimeRegistrationRole
    },
    hasCarrierRole: function () {
      return this.$store.getters['session/hasRole']('CARRIER') && !this.hasTimeRegistrationRole
    },
    hasRepackagingRole: function () {
      return this.$store.getters['session/hasRole']('REPACKAGING') && !this.hasTimeRegistrationRole
    },
    hasLabellerRole: function () {
      return this.$store.getters['session/hasRole']('LABELLER') && !this.hasTimeRegistrationRole
    },
    hasTimeRegistrationRole: function () {
      return this.$store.getters['session/hasRole']('TIME_REGISTRATION')
    },
    numberOfFrontPageButtons: function () {
      let number = 0
      if (this.hasContractorRole) {
        number++
      }
      if (this.hasContractorRole || this.hasLoaderRole || this.hasCarrierRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasLoaderRole || this.hasCarrierRole) {
        number++
      }
      if (this.hasContractorRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasSupplierRole) {
        number++
      }
      if (this.hasRepackagingRole) {
        number++
      }
      if (this.hasLabellerRole) {
        number++
      }
      if (this.hasTimeRegistrationRole) {
        number++
      }
      return number
    }
  },
  methods: {
    gotoHome: function () {
      this.frontPage = true
      this.productionVisible = false
      this.loadingVisible = false
      this.unloadingVisible = false
      this.repackagingVisible = false
      this.labellingVisible = false
      this.timeRegistrationVisible = false
      this.productionReportVisible = false
      this.supplierStatusVisible = false
    },
    gotoProduction: function () {
      this.frontPage = false
      this.productionVisible = true
    },
    gotoLoading: function () {
      this.frontPage = false
      this.loadingVisible = true
    },
    gotoUnloading: function () {
      this.frontPage = false
      this.unloadingVisible = true
    },
    gotoRepackaging: function () {
      this.frontPage = false
      this.repackagingVisible = true
    },
    gotoLabelling: function () {
      this.frontPage = false
      this.labellingVisible = true
    },
    gotoTimeRegistration: function () {
      this.frontPage = false
      this.timeRegistrationVisible = true
    },
    gotoProductionReport: function () {
      this.frontPage = false
      this.productionReportVisible = true
    },
    gotoSupplierStatus: function () {
      this.frontPage = false
      this.supplierStatusVisible = true
    },
    loadContractorPallets: function () {
      this.$store.dispatch('contractor/loadPallets')
    }
  }
}
</script>

<style>
  @import '../assets/css/tablet.css';
</style>



// WEBPACK FOOTER //
// src/components/Todo.vue